import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.0625rem"
      height="1.0625rem"
      viewBox="0 0 14 14"
      version="1.1">
      <title>noun-modify-6569051</title>
      <g
        id="Prompt-Cards"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="3.5.2---Prompt-Cards---prompt-regenerated"
          transform="translate(-995, -705)"
          fill="#53617A"
          fillRule="nonzero">
          <g id="Group-6" transform="translate(948, 521)">
            <g id="Group" transform="translate(9, 174)">
              <g id="noun-modify-6569051" transform="translate(38, 10)">
                <path
                  d="M10.5254246,0.596143613 C11.3202739,-0.198713371 12.6089962,-0.198715704 13.4038455,0.596143613 C14.1987182,1.3910006 14.1987182,2.6797169 13.4038455,3.47456689 L13.2584323,3.61998022 L10.3800113,0.74156161 L10.5254246,0.596143613 Z"
                  id="Path"
                />
                <polygon
                  id="Path"
                  points="9.72002857 1.4015286 4.67538944 6.44618349 7.55383371 9.32460676 12.5984728 4.27996354"
                />
                <path
                  d="M4.17360652,7.26432014 L6.73569772,9.82639009 L4.2811031,10.2595734 C4.13113989,10.2860334 3.97770002,10.2376634 3.87001677,10.1299801 C3.76233353,10.0222967 3.71396357,9.86885675 3.74044688,9.71889342 L4.17360652,7.26432014 Z"
                  id="Path"
                />
                <path
                  d="M12.1333232,7.93333346 C12.1333232,7.67559347 11.9243967,7.4666668 11.6666569,7.4666668 C11.4089172,7.4666668 11.1999907,7.67559347 11.1999907,7.93333346 L11.1999907,12.6 C11.1999907,12.85774 10.9910642,13.0666667 10.7333244,13.0666667 L1.39999883,13.0666667 C1.14226605,13.0666667 0.933332556,12.85774 0.933332556,12.6 L0.933332556,3.26666689 C0.933332556,3.0089269 1.14226605,2.80000023 1.39999883,2.80000023 L6.06666161,2.80000023 C6.3244014,2.80000023 6.53332789,2.59107357 6.53332789,2.33333358 C6.53332789,2.07559358 6.3244014,1.86666692 6.06666161,1.86666692 L1.39999883,1.86666692 C0.626800478,1.86666692 0,2.49347024 0,3.26666689 L0,12.6 C0,13.3731967 0.626800478,14 1.39999883,14 L10.7333244,14 C11.5065204,14 12.1333232,13.3731967 12.1333232,12.6 L12.1333232,7.93333346 Z"
                  id="Path"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
